/* trewrld Revamp — September 2026
 * Subtle 3D tilt-on-hover for product cards.
 * Pairs with assets/revamp-motion.css. Only binds on devices with a
 * fine pointer (mouse/trackpad) and hover support, and does nothing if
 * the visitor has requested reduced motion. Fully additive: removing
 * the <script> include for this file (and the matching CSS include)
 * reverts the theme to its prior behavior with no other changes needed.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var MAX_TILT_DEG = 6;

  function handleMove(event) {
    var wrapper = event.currentTarget;
    var rect = wrapper.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var px = (event.clientX - rect.left) / rect.width;
    var py = (event.clientY - rect.top) / rect.height;
    var tiltY = (px - 0.5) * 2 * MAX_TILT_DEG;
    var tiltX = (0.5 - py) * 2 * MAX_TILT_DEG;
    wrapper.style.setProperty('--tilt-x', tiltX.toFixed(2) + 'deg');
    wrapper.style.setProperty('--tilt-y', tiltY.toFixed(2) + 'deg');
  }

  function resetTilt(event) {
    var wrapper = event.currentTarget;
    wrapper.style.setProperty('--tilt-x', '0deg');
    wrapper.style.setProperty('--tilt-y', '0deg');
  }

  function bind(wrapper) {
    if (wrapper.dataset.revampTiltBound) return;
    wrapper.dataset.revampTiltBound = 'true';
    wrapper.addEventListener('pointermove', handleMove);
    wrapper.addEventListener('pointerleave', resetTilt);
  }

  function bindAll(root) {
    if (!root || !root.querySelectorAll) return;
    var wrappers = root.querySelectorAll('.card-wrapper');
    for (var i = 0; i < wrappers.length; i++) bind(wrappers[i]);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindAll(document);
  });

  // Re-bind newly rendered cards (quick-add re-renders, infinite scroll, etc.)
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      bindAll(event.target);
    });
  }
})();
